import type { SecurityLoggingRow } from '../../codingconstitution/framework';

type Props = { items?: SecurityLoggingRow[] };

export function SecurityLoggingErrorPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.category}-${item.control}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs font-medium text-brand-600">{item.category}</p>
          <p className="mt-1 text-sm">{item.control}</p>
          <span className="mt-1 inline-block rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300">
            {item.status}
          </span>
        </div>
      ))}
    </div>
  );
}
